require("!!/usr/src/cube/node_modules/script-loader/addScript.js")(require("!!/usr/src/cube/node_modules/raw-loader/index.js!/usr/src/cube/src/analytics/legacy/framework/events/AnalyticsQueueEvent.legacy.js"))


//////////////////
// WEBPACK FOOTER
// ./src/analytics/legacy/framework/events/AnalyticsQueueEvent.legacy.js
// module id = 805
// module chunks = 31